import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';
import { ArticleContent, RegisterPageCmsResource } from '@cardihab/content-cache';
import { ContentService } from 'src/app/services/content.service';
import { CLINICIAN } from 'src/app/utils/constants';

@Component({
  selector: 'site-modal',
  templateUrl: 'site-modal.html',
  styleUrls: ['./site-modal.scss'],
})
export class SiteModalPage {
  title = 'What is a Provider Site?';
  clinician: string = CLINICIAN;
  contents: ArticleContent[] | undefined;
  constructor(
    private docTitle: Title,
    private modalController: ModalController,
    private contentService: ContentService,
  ) {
    this.contentService.watchContent(
      RegisterPageCmsResource,
    ).subscribe(registerInformation => {
      if (registerInformation?.length) {
        const register = registerInformation[0] as RegisterPageCmsResource;
        this.contents = register.sitecode;
      }
    });
    this.docTitle.setTitle(this.title);
  }

  dismiss() {
    this.modalController.dismiss();
  }
}
